var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validacion",class:[_vm.isForResponsive],attrs:{"id":"fbButton"},on:{"click":_vm.doLogin}},[_c('span',[_vm._v("CLICK AQUÍ")])])}
var staticRenderFns = []

export { render, staticRenderFns }